export default __webpack_public_path__ + "static/media/cross.7f7afd91.svg";